export const manifest = (() => {
function __memo(fn) {
	let value;
	return () => value ??= (value = fn());
}

return {
	appDir: "_app",
	appPath: "_app",
	assets: new Set(["favicon.png","media/svg/boa-atmos-ascent.svg","media/svg/boa-travel-rewards.svg","media/svg/capital-one-quicksilver.svg","media/svg/capital-one-savor.svg","media/svg/capital-one-venture.svg","media/svg/chase-freedom-unlimited.svg","media/svg/citi-aadvantage.svg","media/svg/wells-fargo-active-cash.svg"]),
	mimeTypes: {".png":"image/png",".svg":"image/svg+xml"},
	_: {
		client: {start:"_app/immutable/entry/start.DY-7PJnf.js",app:"_app/immutable/entry/app.BhxLpSxU.js",imports:["_app/immutable/entry/start.DY-7PJnf.js","_app/immutable/chunks/Cz-4yBSw.js","_app/immutable/chunks/C75YQU_W.js","_app/immutable/entry/app.BhxLpSxU.js","_app/immutable/chunks/C75YQU_W.js","_app/immutable/chunks/cL9VaPgy.js","_app/immutable/chunks/B4FYT0oR.js","_app/immutable/chunks/DzSV4D8H.js","_app/immutable/chunks/BGk0RnQK.js"],stylesheets:[],fonts:[],uses_env_dynamic_public:false},
		nodes: [
			__memo(() => import('./nodes/0.js')),
			__memo(() => import('./nodes/1.js')),
			__memo(() => import('./nodes/2.js')),
			__memo(() => import('./nodes/3.js')),
			__memo(() => import('./nodes/4.js')),
			__memo(() => import('./nodes/5.js')),
			__memo(() => import('./nodes/6.js')),
			__memo(() => import('./nodes/7.js'))
		],
		remotes: {
			
		},
		routes: [
			{
				id: "/",
				pattern: /^\/$/,
				params: [],
				page: { layouts: [0,], errors: [1,], leaf: 2 },
				endpoint: null
			},
			{
				id: "/api/auth/[...anything]",
				pattern: /^\/api\/auth(?:\/([^]*))?\/?$/,
				params: [{"name":"anything","optional":false,"rest":true,"chained":true}],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/auth/_...anything_/_server.js'))
			},
			{
				id: "/dashboard",
				pattern: /^\/dashboard\/?$/,
				params: [],
				page: { layouts: [0,], errors: [1,], leaf: 3 },
				endpoint: null
			},
			{
				id: "/dashboard/card",
				pattern: /^\/dashboard\/card\/?$/,
				params: [],
				page: { layouts: [0,], errors: [1,], leaf: 4 },
				endpoint: null
			},
			{
				id: "/sign-in",
				pattern: /^\/sign-in\/?$/,
				params: [],
				page: { layouts: [0,], errors: [1,], leaf: 5 },
				endpoint: null
			},
			{
				id: "/sign-up",
				pattern: /^\/sign-up\/?$/,
				params: [],
				page: { layouts: [0,], errors: [1,], leaf: 6 },
				endpoint: null
			},
			{
				id: "/thank-you",
				pattern: /^\/thank-you\/?$/,
				params: [],
				page: { layouts: [0,], errors: [1,], leaf: 7 },
				endpoint: null
			}
		],
		prerendered_routes: new Set([]),
		matchers: async () => {
			
			return {  };
		},
		server_assets: {}
	}
}
})();

export const prerendered = new Set([]);

export const base = "";